import React from "react";
import Question from "./question";

const questions = [
  {
    q: 'How to use this',
    a: 'Just follow the Twitter account which tweets about the product you want, turn on notifications and you\'re done. You can also <a href="https://discord.gg/NDv2HdmTAD ">join the Discord server</a> with thousands of members.'
  },
  {
    q: 'Does the bot buy any products?',
    a: '<b>No!</b> This bot doesn\'t buy anything - it just observes stock availability and announces changes on Twitter. It doesn\'t try to give anyone an unfair advantage and just want to help ' +
      'in getting notified when stock changes.'
  },
  {
    q: 'Which shops and products are currently being crawled?',
    a: 'Please refer to this <a href="https://ilox.nehalist.io" target="_blank" rel="noreferrer">page</a> for seeing which products are being tracked.'
  },
  {
    q: 'Why are there no price limits?',
    a: 'Because I\'m not in the position of deciding what\'s "too expensive". Believe me when I tell you that even if you think a price is completely ridiculous - someone\'s going to buy it.\n'
  },
  {
    q: 'How was this made?',
    a: 'It runs on a Lenovo ThinkCentre M720q and is written in NodeJS / Typescript. It uses AWS DynamoDB for storage and uses Axios for HTTP requests and cheerio for parsing them. The polling frequency is 90s - an amount to cause as little additional load on shop servers as possible.'
  },
  {
    q: 'Why is the Twitter bot faster than the Discord bot (or vice versa)?',
    a: 'Please DO NOT confuse your phone notification settings with the bot. It\'s technically absolutely impossible for the Twitter accounts to be faster or slower than the bot here. Twitter and Discord use the exact same bot instance. The bot is programmed to broadcast to all channels simultaneously whenever a stock change occurs. Just because you get a Twitter notification later than the Discord notification doesn\'t mean that the bot was faster in broadcasting on Discord. Just compare the timestamps of the tweet and the discord message and you\'ll see that they\'re identical.'
  },
  {
    q: 'The bot missed stock availability - why?',
    a: 'This could have multiple reasons. Retailers sometimes change the code of their shop which may lead to the bot having no idea on how to acquire the current stock. Another reason ' +
      'would be an error response from the retailers server while trying to acquire the current stock. Or the stock could have changed multiple times within the delay of the bot checking ' +
      'the status.<br>' +
      'These problems are not exclusive to the bot here - every site crawler has to deal with them.<br>' +
      'Some stock changes are also filtered; the Amazon crawler for example ignores updates which start with "Available from" (or "Erhältlich bei" for the german version).'
  },
  {
    q: 'Why are some links posted by the bot marked with [A]?',
    a: 'Links with an [A] are affiliate links.'
  },
  {
    q: 'What\'s the ilox utility script and where to find it?',
    a: 'See <a href="https://github.com/ilox/utility-script/wiki" target="_blank" rel="noreferrer">here</a>.'
  },
];

function Faq() {
  return (
    <section className="bg-gray-100 py-8" id="faq">
      <div className="container mx-auto px-2 pt-4 pb-12 text-gray-800">
        <div className="mx-auto max-w-6xl">
          <div className="p-2 bg-gray-100 rounded">
            <div className="flex flex-col md:flex-row">
              <div className="md:w-1/3 p-4 text-sm">
                <div className="text-3xl">Frequently asked <span className="font-medium">Questions</span></div>
                <div className="my-2">Before being confused, yelling at me or even wishing me not getting a new GPU please read the FAQ.</div>
              </div>
              <div className="md:w-2/3">
                {questions.map((q, key) => (
                  <Question question={q} key={key}/>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;
